/* global angular */

/**
* Focus Module
*
* Manage focus state of a thread
*/
angular
.module('gc.focus', [])
.service('FocusService', ['$document', '$timeout', function($document, $timeout) {
  'use strict';
  var focusId, focusNode;

  this.focusActivated = function() {
    return typeof focusId !== 'undefined';
  };

  this.getFocusId = function() {
    return focusId;
  };

  this.activate = function(id) {
    focusId = id;
    focusNode = $document[0].getElementById('comment-' + id);
    $document.on('mousedown', this.detectClickOutside);
  };

  this.desactivate = function() {
    $timeout(function(){
      focusNode = undefined;
      focusId = undefined;
    }, 0);

    $document.off('mousedown', this.detectClickOutside);
  };

  this.detectClickOutside = function(event) {
    // dont desactivate() if ..
    if (
      // opening menu
      $(event.target).closest('.gc-profile-wrapper').length ||
      // or enable editor mode
      $(event.target).closest('.list-menu-item-editor').length
    ) {
      return;
    }

    if (focusNode && event.target !== focusNode && !focusNode.contains(event.target)){
      event.preventDefault();
      this.desactivate();
    }
  }.bind(this);

  $document.on('click', this.detectClickOutside.bind(this));

}]);
